export default "__VITE_ASSET__BP_no5c$__"